export default __webpack_public_path__ + "static/media/LAS0002.34I-35167_-20420_0.51aa177b.jpg";